<template>
  <container v-if="rerendered">
    <collapsible
      max-height="176px"
      v-if="$root.selectedSectionIndex !== null"
      bg-color="transparent"
      :bg-color-lightness="null"
      :color="$dark ? 'white' : 'black'"
      :color-lightness="null"
      bg-color-expanded="gray"
      :bg-color-lightness-expanded="$dark ? 900 : 200"
      :color-expanded="$dark ? 'white' : 'black'"
      :color-lightness-expanded="null"
      :disabled="false"
      :multiple="false"
      :padding-off="true">
      <collapsible-item v-for="(section, index) in navSections" :label="section.label" :icon="section.icon" :multiple="isSitemap" :expanded="!isSitemap ? index === $root.selectedSectionIndex : true" :key="index">
        <list :divider="false">
          <list-item v-if="!item.hidden" :title="item.title" tag="router-link" :to="item.path" v-for="(item, i) in getNavigationSection(section.type)" :key="i">
            <list-item-avatar hidden>
              <icon :name="item.icon" />
            </list-item-avatar>
            <list-item-content>
              <list-item-content-title :class="['pl-8']" v-html="item.title" />
            </list-item-content>
            <list-item-icon>
              <icon name="chevron-right" />
            </list-item-icon>
          </list-item>
        </list>
      </collapsible-item>
    </collapsible>
  </container>
</template>
<script>
import methods from '../mixins/methods'

export default {
  name: 'Navigation',
  mixins: [
    methods
  ],
  data () {
    return {
      rerendered: true,
      navSections: this.$config.navSections
    }
  },
  props: {
    isSitemap: {
      type: Boolean
    }
  },
  watch: {
    $dark () {
      this.rerendered = false
      this.$nextTick(() => {
        this.rerendered = true
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/navigation.vue